import SunEditor from "suneditor-react";
import { SunEditorOptions } from "suneditor/src/options";
import "suneditor/dist/css/suneditor.min.css";
import "../assets/css/Suneditor.css";
import React from "react";

const textIsProbablyEmpty = (text: string) => {
  const testDiv = document.createElement("div");
  testDiv.innerHTML = text;

  if (testDiv.querySelector("img") != null || testDiv.querySelector("video")) return false;

  return testDiv.innerText === "";
};

const Editor = ({
  textareaName,
  defaultValue,
  onChange,
}: {
  textareaName: string;
  defaultValue: string;
  onChange: (value: string) => void;
}) => {
  const buttonList = [
    ["codeView"],
    ["undo", "redo"],
    ["font", "fontSize", "formatBlock", "fontColor"],
    ["bold", "underline", "italic", "strike", "subscript", "superscript"],
    ["indent", "outdent", "align"],
    ["image", "link", "video"],
  ];
  const handleContentChange = (content: string) => {
    if (textIsProbablyEmpty(content)) {
      onChange("");
    } else {
      onChange(content);
    }
  };

  return (
    <SunEditor
      defaultValue={defaultValue}
      name={textareaName}
      onChange={handleContentChange}
      setDefaultStyle={""}
      setOptions={
        {
          maxHeight: "50vh",
          height: "auto",
          showPathLabel: false,
          buttonList: buttonList,
          strictMode: false,
        } as SunEditorOptions
      }
    />
  );
};

export default Editor;
